import React, { useState } from 'react';

const FadeImage = ({ src, alt, className, fallback, ...props }) => {
    const [isLoaded, setIsLoaded] = useState(false);

    return (
        <div className={`relative overflow-hidden ${className}`}>
            {/* Skeleton / Placeholder while loading */}
            {!isLoaded && (
                <div className="absolute inset-0 bg-gray-200 animate-pulse" />
            )}

            {/* The Image */}
            <img
                src={src}
                alt={alt}
                className={`w-full h-full object-cover transition-opacity duration-500 ease-in-out ${isLoaded ? 'opacity-100' : 'opacity-0'}`}
                onLoad={() => setIsLoaded(true)}
                onError={(e) => {
                    if (fallback && e.target.src !== fallback) {
                        e.target.src = fallback;
                    } else {
                        e.target.src = '/images/placeholder.png';
                    }
                    setIsLoaded(true); // Show placeholder if error
                }}
                {...props}
            />
        </div>
    );
};

export default FadeImage;
// Revisado: 2025-12-18 [I18n Scan]
